// extracted by mini-css-extract-plugin
export default {"task__container":"Task_task__container__iRzyk","task__text":"Task_task__text__caazL","task__checked":"Task_task__checked__kFcvi","task__trash":"Task_task__trash__WEYUl"};